<template>
  <div class="bizum-main">
    <div class="bizum-button-fill">
      <button
        @click="startRedsysPayment()"
        class="bizum-button"
        type="button"
        aria-label="Bizum Pay"
        :disabled="disablePaymentButton"
        :class="{ disabled: disablePaymentButton }"
      ></button>
    </div>

    <redsys-form
      v-if="redsysForm && redsysForm.body"
      :redsysForm="redsysForm"
    ></redsys-form>
  </div>
</template>
<script>
import RedsysForm from "@/components/public/payment/bizum/RedsysForm";
import paymentsMixin from "@/mixins/payment/paymentsMixin";

import {
  randomTransactionId,
  Redsys,
  SANDBOX_URLS,
  PRODUCTION_URLS,
  TRANSACTION_TYPES
} from "redsys-easy";
const NO_QR = "NO QR";
export default {
  name: "BizumPayment",
  props: [
    "totalPrice",
    "disablePaymentButton",
    "unpaidTotalPrice",
    "tableQR",
    "dividePayment"
  ],
  mixins: [paymentsMixin],
  components: {
    RedsysForm
  },
  data() {
    return {
      loading: false,
      redsysForm: {},
      paymentType: "products",
      paymentMethod: "redsys"
    };
  },
  computed: {
    cart() {
      return this.$store.state.cart;
    },
    totalAmount() {
      const { cart } = this.$store.state;
      return cart.reduce((acc, item) => acc + item.quantity * item.price, 0);
    }
  },
  watch: {
    redsysForm: {
      deep: true,
      handler() {
        setTimeout(() => {
          // Send form to redsys
          document.getElementById("redsysForm").submit();
        }, 0);
      }
    }
  },
  methods: {
    startRedsysPayment() {
      if (!this.tableQR || this.tableQR === NO_QR) {
        this.checkQR = true;
        this.$emit("checkQRUpdate", this.checkQR);
        return;
      }
      this.checkoutRedsys();
    },
    async checkoutRedsys() {
      const orderId = randomTransactionId();

      let paymentId = await this.initPayment({
        orders: this.cart,
        paymentMethod: "bizum",
        amount: this.totalAmount,
        orderAmount: this.totalAmount,
        paymentType: this.paymentType,
        externalPaymentId: orderId
      });

      let redsys = new Redsys({
        secretKey: process.env.VUE_APP_REDSYS_SECRET_KEY,
        urls:
          process.env.VUE_APP_REDSYS_SANDBOX === "true"
            ? SANDBOX_URLS
            : PRODUCTION_URLS
      });

      const obj = {
        amount: parseInt(this.totalPrice * 100),
        currency: "EUR",
        order: orderId,
        merchantName: process.env.VUE_APP_REDSYS_MERCHANT_NAME,
        merchantCode: process.env.VUE_APP_REDSYS_MERCHANT_CODE,
        terminal: "1",
        transactionType: TRANSACTION_TYPES.AUTHORIZATION, // '0'
        merchantURL: `https://${process.env.VUE_APP_REGION}-${process.env.VUE_APP_PROJECT_ID}.cloudfunctions.net/paymentSuccess?paymentId=${paymentId}`,
        successURL: `${this.projectUrl}/success-bizum?p_id=` + paymentId,
        errorURL: `${this.projectUrl}/?qr=${this.tableQR}`,
        payMethods: "z"
      };

      localStorage.setItem(
        "missingAmountToPay",
        parseFloat(this.unpaidTotalPrice).toFixed(2)
      );
      localStorage.setItem("amountToBePaid", this.totalPrice);
      localStorage.setItem("isPaid", "true");
      if (this.dividePayment === "todo") {
        localStorage.setItem("payment_type", "todo");
      } else if (this.dividePayment === "amount") {
        localStorage.setItem("payment_type", "amount");
      } else {
        localStorage.setItem("payment_type", "product");
      }

      try {
        this.redsysForm = await redsys.redirectPetition(obj);
      } catch (error) {
        console.error(error);
        this.showErrorMessage(this.$t("payment.petitionRejected"));
        this.dialog = false;
      }
    }
  }
};
</script>
<style scoped lang="scss">
form#redsysForm {
  display: inline-block;
}

.card-design {
  padding: 0 0 0 10px;
}
</style>
